/**
 * Divides an array into two parts based on a callback condition.
 * @param array - The array to divide.
 * @param callback - The callback function used to test each element. If it
 * returns true, the element goes into the first part; otherwise, it goes into
 * the second part.
 * @returns A tuple with two arrays: the first containing elements that satisfy
 * the condition, and the second containing elements that do not.
 */
export function divideArray<T>(
  array: T[],
  callback: (element: T) => boolean,
): [T[], T[]] {
  const trueArray: T[] = [];
  const falseArray: T[] = [];

  for (const element of array) {
    if (callback(element)) {
      trueArray.push(element);
    } else {
      falseArray.push(element);
    }
  }

  return [trueArray, falseArray];
}
